module.exports = __webpack_public_path__ + "img/risk-low.988a5bdf.png";